import mapboxgl from './mapboxgl';
var setRTLTextPlugin = mapboxgl ? mapboxgl.setRTLTextPlugin : function () {};
export default setRTLTextPlugin;
//# sourceMappingURL=set-rtl-text-plugin.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-map-gl/dist/esm/utils/set-rtl-text-plugin.js
// module id = 708
// module chunks = 0 1